import React from "react";
import { Col, Container, Row } from "reactstrap";
import { NavLink, useLocation } from "react-router-dom";
import who from "../assets/img/measure-malaria.png";
import cdc from '../assets/img/cdc.png'
import ug from "../assets/img/ug.jpg";
import ghs from "../assets/img/ghs-logo.jpg";

const Footer = () => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <footer className="footer">
      <hr className="horizontal dark mb-5 mt-0" />
      <Container className="">
        <Row className="">
          <Col className="mb-4 mx-auto text-center">
            <div>
              <h6 className="font-weight-bolder">
                Anglophone Regional Workshop <br />
                Surveillance, Monitoring, and Evaluation (SM&E) of Malaria
                Control Programs
              </h6>
            </div>
            <div>
              <h6 className="text-left mt-3 mb-2 opacity-8">For Information</h6>
              <Row>
                <Col lg={2} md={3} sm={6} xs={6}>
                  <div className={"text-left mb-2"}>
                    <ul className="flex-column ms-n3 nav">
                      <li className="nav-item">
                        <span className="nav-link font-weight-bold">
                          Edith Tetteh
                        </span>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href="mailto:m.e.malaria@gmail.com"
                        >
                          m.e.malaria@gmail.com
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="tel:+233249410336">
                          +233 (0)24 941 0336
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col lg={2} md={3} sm={6} xs={6}>
                  <div className={"text-left mb-2"}>
                    <ul className="flex-column ms-n3 nav">
                      <li className="nav-item">
                        <span className="nav-link font-weight-bold">
                          Dr. Paul Boateng
                        </span>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="tel:+233242748336">
                          +233 (0)24 274 8336
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col lg={2} md={3} sm={6} xs={6}>
                  <div className={"text-left mb-2"}>
                    <ul className="flex-column ms-n3 nav">
                      <li className="nav-item">
                        <span className="nav-link font-weight-bold">
                          Hammond Sarkwah
                        </span>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="tel:+233243127089">
                          +233 (0)24 312 7089
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col lg={2} md={3} sm={6} xs={6}>
                  <div className={"text-left mb-2"}>
                    <ul className="flex-column ms-n3 nav">
                      <li className="nav-item">
                        <span className="nav-link font-weight-bold">
                          Yvonne Torto
                        </span>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="tel:+233542309881">
                          +233 (0)54 230 0881
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="tel:+233268485022">
                          +233 (0)26 848 5022
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col lg={2} md={3} sm={6} xs={6}>
                  <div className={"text-left mb-2"}>
                    <ul className="flex-column ms-n3 nav">
                      <li className="nav-item">
                        <span className="nav-link font-weight-bold">
                          Cynthia Afetsi
                        </span>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="tel:+233277387307">
                          +233 (0)27 738 7307
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
            { /*<Row>
              <Col lg={2} md={3} sm={6} xs={6}>
                <div>
                  <h6 className="mt-3 mb-2 opacity-8">Social</h6>
                  <ul className="d-flex flex-row ms-n3 nav justify-content-center">
                    <li className="nav-item">
                      <NavLink to={pathname} className="nav-link pe-1">
                        <i className="fa fa-facebook text-lg opacity-8" />
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={pathname} className="nav-link pe-1">
                        <i className="fa fa-twitter text-lg opacity-8" />
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={pathname} className="nav-link pe-1">
                        <i className="fa fa-youtube text-lg opacity-8" />
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row> */}
          </Col>
          {/*<Col md={2} sm={6} xs={6} className="mb-4">
            <div>
              <h6 className="text-gradient text-danger text-sm font-weight-bold">
                Contact
              </h6>
              <ul className="flex-column ms-n3 nav">
                <li className="nav-item">
                  <NavLink to={pathname} className="nav-link">
                    Edith Tetteh
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={pathname} className="nav-link">
                    m.e.malaria@gmail.com
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={pathname} className="nav-link">
                    +233 (0)24 941 0336
                  </NavLink>
                </li>
              </ul>
            </div>
          </Col>
          <Col md={2} sm={6} xs={6} className="mb-4 me-auto">
            <div>
              <h6 className="text-gradient text-danger text-sm font-weight-bold">
                Sponsors
              </h6>
              <ul className="flex-column ms-n3 nav">
                <li className="nav-item">
                  <NavLink to={pathname} className="nav-link">
                    MTN
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={pathname} className="nav-link">
                    Vodafone
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={pathname} className="nav-link">
                    USAID
                  </NavLink>
                </li>
              </ul>
            </div>
          </Col>
          <div className="col-md-2 col-sm-6 col-6 mb-4">
              <div>
                <h6 className="text-gradient text-danger text-sm">
                  Help & Support
                </h6>
                <ul className="flex-column ms-n3 nav">
                  <li className="nav-item">
                    <NavLink to={pathname}
                      className="nav-link"
                      href="https://www.creative-tim.com/contact-us"
                      target="_blank"
                    >
                      Contact Us
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={pathname}
                      className="nav-link"
                      href="https://www.creative-tim.com/knowledge-center"
                      target="_blank"
                    >
                      Knowledge Center
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={pathname}
                      className="nav-link"
                      href="https://services.creative-tim.com/?ref=ct-soft-ui-footer"
                      target="_blank"
                    >
                      Custom Development
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={pathname}
                      className="nav-link"
                      href="https://www.creative-tim.com/sponsorships"
                      target="_blank"
                    >
                      Sponsorships
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 col-6 mb-4 me-auto">
              <div>
                <h6 className="text-gradient text-danger text-sm">Legal</h6>
                <ul className="flex-column ms-n3 nav">
                  <li className="nav-item">
                    <NavLink to={pathname}
                      className="nav-link"
                      href="https://www.creative-tim.com/terms"
                      target="_blank"
                    >
                      Terms &amp; Conditions
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={pathname}
                      className="nav-link"
                      href="https://www.creative-tim.com/privacy"
                      target="_blank"
                    >
                      Privacy Policy
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={pathname}
                      className="nav-link"
                      href="https://www.creative-tim.com/license"
                      target="_blank"
                    >
                      Licenses (EULA)
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>*/}
          <div className="col-12">
            <div className="text-center mb-2">
              <p className="my-4 text-sm">
                All rights reserved. Copyright © {new Date().getFullYear()}{" "}
                SM&E.
              </p>
              <p className={"text-sm"}>
                This project was made possible by the generous support of the
                American people through the United States Agency for
                International Development (USAID) and the U.S. President’s
                Malaria Initiative (PMI) under the terms of the PMI Measure
                Malaria Associate Award No. 7200AA19LA00001. PMI Measure Malaria
                is implemented by the University of North Carolina at Chapel
                Hill, in partnership with ICF Macro, Inc.; Tulane University;
                John Snow, Inc.; and Palladium International, LLC. The contents
                do not necessarily reflect the views of USAID/PMI or the United
                States Government
              </p>
              <div className="row justify-content-center">
                <div className="" style={{ width: "100px" }}>
                  <img src={ghs} alt="" className={"w-100"} />
                </div>
                <div className="" style={{ width: "180px" }}>
                  <img src={ug} alt="" className={"w-100"} />
                </div>
                <div className="" style={{ width: "200px", display: 'flex', alignItems: "center" }}>
                  <img src={cdc} alt="" className={"w-200"} />
                </div>
                <div className="" style={{ width: "200px", display: 'flex', alignItems: "center" }}>
                  <img src={who} alt="" className={"w-100"} />
                </div>
                {/* <img src={supporters} alt="" className={"w-auto"} /> */}
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
